import DASHED_LINE from 'assets/overview/dashed-line.png'
import POWERED_BANNER from 'assets/overview/powered-whale-logo.png'
import BANNER_IMAGE from 'assets/splash-artx-ai-banner.png'
import TWITTER_BANNER from 'assets/twitter-banner.png'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import React from 'react'
import { OverviewProps } from './overview-wrapper'
import ProductExposure from './pages/exposure'
import { InTheNumbers } from './pages/number-container/index'
import { SmartProducts } from './pages/smart-products/index'
import SplashComponent from './pages/splash'
import { partnersList } from './service'
import {
  DashedLineImage,
  DesktopOverviewContainer,
  FittedBannerImage,
  FullWidthBannerWrapper,
  PartnerItem,
  PartnerLogo,
  PartnerName,
  PartnersBlockContentWrapper,
  PartnersBottomText,
  PartnersWrapper,
  PoweredTitleWrapper,
  StyledPoweredTitle,
  StyledWhaleImage,
  WhitePaperContainer,
  WhitePaperContentWrapper,
  WhitePaperDescription,
  WhitePaperTitle,
  WhitepaperButton,
} from './styled'

const DesktopOverview: React.FC<OverviewProps> = ({ overviewProducts }) => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.Overview)

  const downloadWhitePaper = () => {
    window.open('/phuture-v2-core.pdf', '_blank')
  }

  return (
    <DesktopOverviewContainer>
      <SplashComponent />
      <FullWidthBannerWrapper onClick={() => navigationEvent('/products/artxai')}>
        <FittedBannerImage src={BANNER_IMAGE} />
      </FullWidthBannerWrapper>
      <ProductExposure products={overviewProducts} />
      <WhitePaperContainer>
        <WhitePaperContentWrapper>
          <WhitePaperTitle>
            Phuture 2.0 —<br /> <i>borderless</i> crypto investing
          </WhitePaperTitle>
          <WhitePaperDescription>
            With Phuture 2.0, you can invest in index funds that include assets across the most
            popular networks
          </WhitePaperDescription>
          <WhitepaperButton buttonType="light-secondary" onClick={downloadWhitePaper}>
            View whitepaper
          </WhitepaperButton>
        </WhitePaperContentWrapper>
      </WhitePaperContainer>
      <PartnersBlockContentWrapper>
        <PoweredTitleWrapper>
          <StyledPoweredTitle>Powered by Phuture</StyledPoweredTitle>
          <StyledWhaleImage src={POWERED_BANNER} />
        </PoweredTitleWrapper>
        <DashedLineImage src={DASHED_LINE} />
        <PartnersWrapper>
          {partnersList.map(({ name, icon, link }) => (
            <PartnerItem key={`${name}-partner`} onClick={() => navigationEvent(link, true)}>
              <PartnerLogo src={icon} />
              <PartnerName>{name}</PartnerName>
            </PartnerItem>
          ))}
        </PartnersWrapper>
        <PartnersBottomText>
          Phuture’s asset management platform is powering some of the biggest Web3 index products.
        </PartnersBottomText>
      </PartnersBlockContentWrapper>
      <SmartProducts />
      <FullWidthBannerWrapper
        onClick={() => navigationEvent('https://twitter.com/phuture_finance', true)}
      >
        <FittedBannerImage src={TWITTER_BANNER} />
      </FullWidthBannerWrapper>
      <InTheNumbers />
    </DesktopOverviewContainer>
  )
}
export default DesktopOverview
